import { render } from "./TheNganHang.vue?vue&type=template&id=791ae77b"
import script from "./TheNganHang.vue?vue&type=script&lang=js"
export * from "./TheNganHang.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__